import { Checkbox, Stack } from 'component-library';

import { Picker, PickerContent, PickerTrigger } from '@/components/widgets/o/Form/Picker';

import { MapFilter } from './constants';
import { handleFilterUpdate, MapLayerFilter, SetMapLayerFilter } from './hooks/useMapLayerFilter';

type DropdownMapFilterProps = {
  filter: MapFilter;
  setMapFilter: SetMapLayerFilter;
  mapFilter: MapLayerFilter;
};

export const DropdownMapFilter = ({ filter, setMapFilter, mapFilter }: DropdownMapFilterProps) => {
  const { label, filterKey, filterValues, filterOperator } = filter;

  const handleItemClick = (value: string | boolean | null | undefined) => {
    if (typeof value !== 'string') {
      return;
    }

    const isValueSelected = mapFilter.value.includes(value);
    const newValue = isValueSelected ? mapFilter.value.filter((item) => item !== value) : [...mapFilter.value, value];

    handleFilterUpdate({
      filterKey,
      filterValue: newValue,
      filterOperator,
      setFilters: setMapFilter,
    });
  };

  return (
    <Picker>
      <PickerTrigger>{label}</PickerTrigger>
      <PickerContent>
        <Stack spacing={2}>
          {filterValues.map((item) => (
            <Checkbox key={item} onCheckedChange={() => handleItemClick(item)} checked={mapFilter.value.includes(item)}>
              <span className='typography-body2 text-text-primary'>{item}</span>
            </Checkbox>
          ))}
        </Stack>
      </PickerContent>
    </Picker>
  );
};
